/** UI copy for DigiPainto — Svenska + English */
export const SUPPORTED = [
  { code: 'sv', label: 'Svenska', flag: 'SE' },
  { code: 'en', label: 'English', flag: 'GB' },
];

const CONTACT = {
  email: 'digipainto.no@silverlines.info',
  hotline: '+47 21 95 58 81',
  smsKeyword: 'DGP',
  stopKeyword: 'STOPP DGP',
  shortcode: '2189',
  countryCode: '+47',
  countryFlag: 'NO',
  pricePerWeek: '50 kr',
};

export const contact = CONTACT;

export const strings = {
  sv: {
    brand: 'DigiPainto',
    brandDomain: 'digipainto.com',
    nav: {
      home: 'Hem',
      gallery: 'Galleri',
      features: 'Funktioner',
      legal: 'Juridisk information',
      terms: 'Allmänna villkor',
    },
    headerCta: 'Skapa nu',
    hero: {
      badge: 'AI-driven bildgenerator',
      title: 'DigiPainto',
      tagline:
        'Skapa enkelt fantastiska och unika bilder med vår AI-drivna bildgenerator!',
      formLabel: 'Ange ditt telefonnummer',
      phonePlaceholder: '90 12 34 56',
      submit: 'BETALA NU',
      priceNote:
        'Aktivera prenumerationen 50 kr per vecka. Avsluta prenumerationen: STOPP DGP till 2189. DigiPainto, AI-bildgenerator. För mer information skicka e-post till: digipainto.no@silverlines.info eller ring hotline: +47 21 95 58 81 .',
      legalLong:
        'Så fungerar DigiPainto-tjänsten: deltagarna registrerar sig med sitt mobilnummer och bekräftar registreringen, samt framtida betalningar, genom att svara med en PIN-kod som tas emot via SMS. På så sätt accepterar deltagaren att han eller hon har läst och förstått villkoren och accepterar prenumerationen på tjänsten. Denna tjänst kostar 50 kr per vecka inkl. moms. Detta faktureras via mobilräkningen eller dras automatiskt från kontantkortets saldo. Detta är en prenumerationstjänst som automatiskt förnyas varje vecka. Du kan när som helst avsluta din prenumeration genom att skicka SMS till 2189 med kodordet STOPP DGP. Om tjänsten inte avbryts förnyas den automatiskt för en ny vecka. För support, ring +47 21 95 58 81 eller skicka e-post till digipainto.no@silverlines.info. Åldersgräns 18 år. Denna tjänst tillhandahålls av MobileBoost.',
    },
    stats: [
      { value: '250K+', label: 'Genererade bilder' },
      { value: '50+', label: 'Konststilar' },
      { value: '99%', label: 'Kundnöjdhet' },
      { value: '24/7', label: 'Tillgänglighet' },
    ],
    gallery: {
      title: 'Exempel på genererade bilder',
      subtitle:
        'Upptäck kraften i vår AI genom dessa skapelser gjorda av våra användare',
      styleLabel: 'Stil',
      items: [
        {
          title: 'Söt robot',
          style: 'AI',
          prompt: 'en söt robot vid ett dukat bord',
          author: 'Marie D.',
          role: 'Designer',
        },
        {
          title: 'Manga-cykel',
          style: 'Manga',
          prompt: 'en man som cyklar i manga-stil med en solnedgång',
          author: 'Thomas L.',
          role: 'Illustratör',
        },
        {
          title: 'AI-drake',
          style: 'Fantasy',
          prompt: 'en snäll drake som flyger över havet vid solnedgången',
          author: 'Sophie M.',
          role: 'Författare',
        },
        {
          title: 'AI-kattunge',
          style: 'Söt',
          prompt: 'en söt kattunge ovanifrån som tittar på oss',
          author: 'Julie B.',
          role: 'Fotograf',
        },
        {
          title: 'AI-luftballong',
          style: 'Surrealistisk',
          prompt: 'en luftballong som flyger över månen',
          author: 'Pierre L.',
          role: 'Konstnär',
        },
        {
          title: 'Land Rover i snö',
          style: 'Realistisk',
          prompt: 'land rover discovery 4 i snö',
          author: 'Marc T.',
          role: 'Bilentusiast',
        },
      ],
    },
    features: {
      title: 'Nyckelfunktioner',
      subtitle: 'Allt du behöver för att ge liv åt din kreativitet',
      items: [
        {
          title: 'Högkvalitativ bildgenerering',
          description:
            'Skarpa, detaljerade och professionella visuella material, anpassade för alla dina behov (print, digitalt, sociala medier).',
        },
        {
          title: 'Avancerade AI-algoritmer',
          description:
            'Banbrytande modeller som förstår dina instruktioner och anpassar sig till din stil för unika resultat.',
        },
        {
          title: 'Flera enheter',
          description:
            'Användbar på mobil, surfplatta eller dator, utan installation. Din kreativitet följer dig överallt.',
        },
        {
          title: 'Olika format & stilar',
          description:
            'Från akvarell till serietidningsstil – utforska ett brett kreativt spektrum och byt stil med ett klick.',
        },
        {
          title: 'Flexibla priser',
          description:
            'Abonnemang som passar alla behov, utan bindningstid. Betala bara för det du behöver.',
        },
        {
          title: 'Intuitivt gränssnitt',
          description:
            'Inga tekniska färdigheter krävs: ett tydligt, enkelt och guidat gränssnitt för alla skapare.',
        },
      ],
    },
    about: {
      kicker: 'Om tjänsten',
      title: 'DigiPainto',
      intro:
        'Efter att ha köpt DigiPainto-pass får användarna tillgång till AI-bildgeneratorn och kan börja skapa fantastiska visuella verk. Tjänsten kostar 50 kr per vecka.',
      activation:
        'För att aktivera tjänsten, svara med PIN-koden du fick via SMS.',
      paragraphs: [
        'Genom att aktivera tjänsten bekräftar du att du har tagit del av de allmänna villkoren och accepterar att gratis ta emot marknadsförings- och reklaminformation från tjänsteleverantören.',
        'Avgifterna inkluderar inte användning av mobilt internet.',
        'Tjänsteleverantör: MobileBoost, 25 avenue de Verdun, 06500 Menton FRANKRIKE.',
      ],
    },
    footer: {
      linksTitle: 'Nyttiga länkar',
      blurb:
        'DigiPainto — skapa enkelt fantastiska och unika bilder med vår AI-drivna bildgenerator.',
      contactTitle: 'Kontakt',
      copyright:
        '© 2025 digipainto.com - Alla rättigheter förbehållna. Publicerad av MobileBoost',
      address: '25 avenue de Verdun, 06500 Menton FRANKRIKE',
    },
  },

  en: {
    brand: 'DigiPainto',
    brandDomain: 'digipainto.com',
    nav: {
      home: 'Home',
      gallery: 'Gallery',
      features: 'Features',
      legal: 'Legal information',
      terms: 'Terms & Conditions',
    },
    headerCta: 'Create now',
    hero: {
      badge: 'AI-powered image generator',
      title: 'DigiPainto',
      tagline:
        'Easily create stunning and unique images with our AI-powered image generator!',
      formLabel: 'Enter your phone number',
      phonePlaceholder: '90 12 34 56',
      submit: 'PAY NOW',
      priceNote:
        'Activate the subscription 50 kr per week. Cancel the subscription: STOPP DGP to 2189. DigiPainto, AI image generator. For more information email: digipainto.no@silverlines.info or call the hotline: +47 21 95 58 81 .',
      legalLong:
        'How the DigiPainto service works: participants register with their mobile number and confirm the registration, as well as future payments, by replying with a PIN code received via SMS. In this way the participant accepts that he or she has read and understood the terms and accepts the subscription to the service. This service costs 50 kr per week incl. VAT. This will be billed via the mobile bill or automatically deducted from the prepaid card balance. This is a subscription service that automatically renews every week. You can cancel your subscription at any time by sending an SMS to 2189 with the keyword STOPP DGP. If the service is not cancelled, it automatically renews for a new week. For support, call +47 21 95 58 81 or send an email to digipainto.no@silverlines.info. Age limit 18 years. This service is provided by MobileBoost.',
    },
    stats: [
      { value: '250K+', label: 'Generated images' },
      { value: '50+', label: 'Art styles' },
      { value: '99%', label: 'Customer satisfaction' },
      { value: '24/7', label: 'Availability' },
    ],
    gallery: {
      title: 'Examples of generated images',
      subtitle:
        'Discover the power of our AI through these creations made by our users',
      styleLabel: 'Style',
      items: [
        {
          title: 'Cute robot',
          style: 'AI',
          prompt: 'a cute robot at a set table',
          author: 'Marie D.',
          role: 'Designer',
        },
        {
          title: 'Manga cyclist',
          style: 'Manga',
          prompt: 'a man cycling in manga style with a sunset',
          author: 'Thomas L.',
          role: 'Illustrator',
        },
        {
          title: 'AI dragon',
          style: 'Fantasy',
          prompt: 'a friendly dragon flying over the sea at sunset',
          author: 'Sophie M.',
          role: 'Writer',
        },
        {
          title: 'AI kitten',
          style: 'Cute',
          prompt: 'a cute kitten from above looking at us',
          author: 'Julie B.',
          role: 'Photographer',
        },
        {
          title: 'AI hot air balloon',
          style: 'Surreal',
          prompt: 'a hot air balloon flying over the moon',
          author: 'Pierre L.',
          role: 'Artist',
        },
        {
          title: 'Land Rover in snow',
          style: 'Realistic',
          prompt: 'land rover discovery 4 in snow',
          author: 'Marc T.',
          role: 'Car enthusiast',
        },
      ],
    },
    features: {
      title: 'Key features',
      subtitle: 'Everything you need to bring your creativity to life',
      items: [
        {
          title: 'High-quality image generation',
          description:
            'Sharp, detailed and professional visuals, adapted to all your needs (print, digital, social media).',
        },
        {
          title: 'Advanced AI algorithms',
          description:
            'Cutting-edge models that understand your instructions and adapt to your style for unique results.',
        },
        {
          title: 'Multiple devices',
          description:
            'Usable on mobile, tablet or computer, with no installation. Your creativity follows you everywhere.',
        },
        {
          title: 'Various formats & styles',
          description:
            'From watercolor to comic-book style – explore a broad creative spectrum and switch styles with one click.',
        },
        {
          title: 'Flexible pricing',
          description:
            'Subscriptions that fit every need, with no commitment. Pay only for what you need.',
        },
        {
          title: 'Intuitive interface',
          description:
            'No technical skills required: a clear, simple and guided interface for all creators.',
        },
      ],
    },
    about: {
      kicker: 'About the service',
      title: 'DigiPainto',
      intro:
        'After purchasing the DigiPainto pass, users get access to the AI image generator and can start creating amazing visual works. The service costs 50 kr per week.',
      activation:
        'To activate the service, reply with the PIN code you received via SMS.',
      paragraphs: [
        'By activating the service you confirm that you have read the general terms and conditions and agree to receive, free of charge, marketing and promotional information from the service provider.',
        'The fees do not include the use of mobile internet.',
        'Service provider: MobileBoost, 25 avenue de Verdun, 06500 Menton FRANCE.',
      ],
    },
    footer: {
      linksTitle: 'Useful links',
      blurb:
        'DigiPainto — easily create stunning and unique images with our AI-powered image generator.',
      contactTitle: 'Contact',
      copyright:
        '© 2025 digipainto.com - All rights reserved. Published by MobileBoost',
      address: '25 avenue de Verdun, 06500 Menton FRANCE',
    },
  },
};
